module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-5-en.5e23dcb9.png";